import styled from '@emotion/styled';

export const StyledDashboard = styled.div`
  width: 100%;
  max-width: 700px;
  height: 100%;
  max-height: 900px;
  display: grid;
`;
